import { Check } from "lucide-react";

import { t } from "@/lib/localization";
import type { StorageExplorerSettings } from "@/features/storage/useStorage";

type SetExplorerOpen = (
    open: boolean,
    settings?: StorageExplorerSettings
) => void;

/**
 * Open the storage explorer to pick one video, then hand back its file id.
 * Shared by the video block's empty state and the topbar's "Replace video",
 * so both offer the identical picker.
 */
export function openStorageVideoPicker(
    setExplorerOpen: SetExplorerOpen,
    onPick: (videoId: string) => void
) {
    setExplorerOpen(true, {
        description: t("lomda-v3-editor.media.video-picker"),
        actionsButton: { uploadVideos: true },
        folders: {
            onFolderClickActions: ["navigate-to-folder"],
            menuOptions: { select: false },
        },
        files: {
            initialFilterBy: "videos",
            onFileClickActions: ["select-file"],
            menuOptions: { select: true },
        },
        selectedItemsMenu: {
            mode: "single-file",
            buttons: {
                cancel: true,
                custom: {
                    text: t("lomda-v3-editor.media.video-pick"),
                    icon: Check,
                    onClick: (_folders: unknown, files: unknown[]) => {
                        const file = files[0] as { id: string } | undefined;
                        if (file) onPick(file.id);
                        setExplorerOpen(false);
                    },
                },
            },
        },
    });
}
